import { TypographyElement } from 'LuxKit/Typography/Typography'
import devOnlyCss, { InvalidElementStyle } from 'lib/styles/devOnlyCss'
// oxlint-disable-next-line no-restricted-imports
import { getContentColourUtilityClassName } from 'lib/theme/utilityClassNames'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Element = styled.span`
  ${devOnlyCss`
    &:not(${TypographyElement} &) { ${InvalidElementStyle('<Colour> should be child of a typography')} }
  `}
`

type InlineElements = Pick<React.JSX.IntrinsicElements, 'span' | 'b' | 'strong' | 'i' | 'em' | 's' | 'sup' | 'sub' | 'small'>

interface Props extends PropsWithChildren {
  /**
   * @default span
   */
  as?: keyof InlineElements
  value: App.Design.ContentColour
  ref?: React.RefObject<HTMLSpanElement | null>
}

function Colour(
  {
    children,
    as = 'span',
    value,
    ref,
  }: Props) {
  return <Element
    as={as}
    ref={ref}
    className={getContentColourUtilityClassName(value)}
  >
    {children}
  </Element>
}

export default Colour
